<template>
<transition name="fade">

  <div v-show="!hide" class="ui small message" :class="{'info':info, 'warning':warning, 'success': success, 'error': error }" >
    <!--    <i class="close icon" @click="hide = true"></i> -->
    <i class="icon big" :class="[icon]"></i><span>{{text}}</span>
  </div>

</transition>
</template>

<script>
'use strict';
export default {
  name: 'message',
  data() {
    return {
      hide: true,
      type: 'info',
      icon: '',
      text: '',
      info: true,
      warning: false,
      success: false,
      error: false
    }
  },
  methods: {
    show() {
      this.hide = false
      setTimeout(() => { this.hide = true;
      }, 3300);

    },
    hide() {
      this.hide = true;
    },
    setType(type) {
      this.info = false
      this.warning = false
      this.success = false
      this.error = false
      switch (type) {
        case 'info':
          this.info = true
          this.icon = 'info circle'
          break
        case 'warning':
          this.warning = true
          this.icon = 'warning sign'
          break
        case 'success':
          this.success = true
          this.icon = 'hand peace'
          break
        case 'error':
          this.error = true
          this.icon = 'help circle'
          break
      }
    },
    setText(text) {
      this.text = text;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {}

.message {
  z-index: 1100;
  bottom: 0;
  width: 100%;
  position: fixed;
  text-align: center;
  border-radius: 0;
  font-size: 1.1em !important;
  }
.fade-enter-active {
  animation: flyInUp .8s;
}

.fade-leave-active {
  animation: flyOutDown;
}
</style>



// WEBPACK FOOTER //
// Message.vue?54c9e779